import { render, staticRenderFns } from "./stockClick.vue?vue&type=template&id=5c7b99f6&scoped=true"
import script from "./stockClick.vue?vue&type=script&lang=js"
export * from "./stockClick.vue?vue&type=script&lang=js"
import style0 from "./stockClick.vue?vue&type=style&index=0&id=5c7b99f6&prod&lang=scss&scoped=true"
import style1 from "./stockClick.vue?vue&type=style&index=1&id=5c7b99f6&prod&lang=css"
import style2 from "./stockClick.vue?vue&type=style&index=2&id=5c7b99f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7b99f6",
  null
  
)

export default component.exports